import { pxToRem } from 'styles/functions'
import { css } from 'styled-components'

const Theme = {
  body_background_color: '#f5df4d',
  header_border_color: '#939597',

  logo_image_url: 'artotheque.png',

  text_font: `'Gotham', sans-serif`,
  text_weight: 400,

  title_font: `'Open Sans', sans-serif`,
  title_weight: 700,
  title_margin: `${pxToRem(10)} 0 ${pxToRem(10)} ${pxToRem(10)}`,

  button_color: '#939597',
  button_radius: 15,
  button_border_width: 1,
  button_text_size: 15,

  separator_color: '#f5df4d',

  footer_border_color: '#939597',

  custom_token: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: ${pxToRem(50)};
    width: ${pxToRem(50)};
    min-width: ${pxToRem(50)};
    border: ${pxToRem(2)} solid #f5df4d;
    border-radius: 100%;

    img {
      display: none;
    }

    span {
      font-family: Poppins, sans-serif;
      font-size: ${pxToRem(20)};
      font-weight: 600;
      text-transform: uppercase;
    }
  `,
}

export default Theme
